module.exports = "/assets/data/36a850bfebfd0d5776eaf30b2bb3d4bd-GL1.data.json";